var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3712 6.36047C10.0403 6.39095 9.72235 6.46063 9.42188 6.55643H12.1828C11.6167 6.37789 11.007 6.30386 10.3712 6.36047Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47431 11.337C1.47431 11.337 1.45689 11.3283 1.45689 11.3196V10.0872C1.45689 7.94029 3.26847 6.21145 5.44149 6.3508C6.38212 6.41177 7.20952 6.83418 7.82354 7.46997C8.05434 7.26966 8.29821 7.09111 8.56385 6.93869C7.63193 5.94146 6.26454 5.35792 4.77086 5.49292C2.37139 5.71065 0.585938 7.83142 0.585938 10.2396V12.1905C0.585938 12.1905 0.594647 12.2079 0.603357 12.2079H6.1818V11.337H1.47431Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8999 8.84668V12.7485H6.89147V12.2086H6.18164V13.0621C6.18164 13.0621 6.19035 13.0795 6.19906 13.0795H15.3963C15.3963 13.0795 15.4137 13.0708 15.4137 13.0621V10.9587C15.4137 10.1967 15.2221 9.48247 14.8955 8.84668H14.8999Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18164 11.1117V11.3425H6.89147V8.58594C6.44293 9.3306 6.18164 10.2016 6.18164 11.1161V11.1117Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89147 11.3369H6.18164V12.2079H6.89147V11.3369Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0422 7.22194C13.041 7.34823 14.5478 9.10755 14.5478 11.1064V12.1907C14.5478 12.1907 14.5391 12.2081 14.5304 12.2081H9.80546H6.89648V12.7481H14.9049V8.84626C14.3431 7.76193 13.3677 6.93017 12.1875 6.55566H9.4266C9.12612 6.65147 8.84306 6.78211 8.57742 6.93453C8.77338 7.14791 8.95193 7.37436 9.1087 7.62258C9.68788 7.32646 10.3498 7.17404 11.0509 7.21759L11.0422 7.22194Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0522 10.9593C7.0522 9.83143 7.55735 8.82113 8.34556 8.13307C8.1975 7.89356 8.01896 7.67147 7.82299 7.4668C7.45719 7.78469 7.13929 8.1592 6.88672 8.57726V11.3338H7.04784V10.955L7.0522 10.9593Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3507 8.1331C8.57714 7.93279 8.82972 7.76295 9.09971 7.6236C8.94294 7.37973 8.76875 7.14893 8.56843 6.93555C8.30279 7.08796 8.05457 7.26651 7.82812 7.46683C8.02409 7.66715 8.19828 7.88924 8.3507 8.1331Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80546 12.2079H7.07503C7.07503 12.2079 7.05761 12.1992 7.05761 12.1904V11.3369H6.89648V12.2079H9.80546Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20243 1.79185C4.60838 1.79185 4.12681 2.27342 4.12681 2.86747C4.12681 3.46153 4.60838 3.9431 5.20243 3.9431C5.79649 3.9431 6.27806 3.46152 6.27806 2.86747C6.27806 2.27342 5.79649 1.79185 5.20243 1.79185ZM3.25586 2.86747C3.25586 1.79241 4.12737 0.920898 5.20243 0.920898C6.2775 0.920898 7.14901 1.79241 7.14901 2.86747C7.14901 3.94254 6.2775 4.81405 5.20243 4.81405C4.12737 4.81405 3.25586 3.94254 3.25586 2.86747Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8938 2.64146C10.2998 2.64146 9.81822 3.12303 9.81822 3.71708C9.81822 4.31114 10.2998 4.79271 10.8938 4.79271C11.4879 4.79271 11.9695 4.31113 11.9695 3.71708C11.9695 3.12303 11.4879 2.64146 10.8938 2.64146ZM8.94727 3.71708C8.94727 2.64202 9.81878 1.77051 10.8938 1.77051C11.9689 1.77051 12.8404 2.64202 12.8404 3.71708C12.8404 4.79215 11.9689 5.66366 10.8938 5.66366C9.81878 5.66366 8.94727 4.79215 8.94727 3.71708Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.425db651c588054ed578613638384a6c.svg";
export { ForwardRef as ReactComponent };